import { useState, useEffect } from 'react'

import { Loader } from '../../common/components/loader'
import { httpService } from '../../common/services/http.service'
import { contentService } from '../../common/services/content.service'
import { RmarkdownEmptyState } from '../rmarkdown-empty-state'
import { useStyles } from './iframe-report.style'

export const IframeReport = function ({ report, fullHeight = false }) {
  const classes = useStyles()

  const [loading, setLoading] = useState(true)
  const [hasContent, setHasContent] = useState(false)
  const containerIndexUrl = report.containerId
    ? contentService.getUrl(report.containerId, 'index.html')
    : undefined

  useEffect(() => {
    if (containerIndexUrl) {
      checkContentExists()
    } else {
      setHasContent(false)
      setLoading(false)
    }
  }, [ report ])

  async function checkContentExists () {
    setLoading(true)
    const resourceExists = await httpService.checkResourceExists(containerIndexUrl)
    if (resourceExists) {
      setHasContent(true)
    } else {
      setHasContent(false)
    }
    setLoading(false)
  }

  if (loading) {
    return <Loader />
  }

  return (hasContent && containerIndexUrl)
    ? (
      <iframe src={containerIndexUrl} className={fullHeight ? `${classes.iframeFullHeightSafari} ${classes.iframeFullHeight}` : classes.iframe} frameBorder="0" />
    )
    : (
      <div className="page-content-center flex-column">
        <div className={classes.emptyState}>
          <RmarkdownEmptyState report={report} onRefresh={checkContentExists} />
        </div>
      </div>
    )
}
